// extracted by mini-css-extract-plugin
export default {"icon":"mfr-N6cV7imh"};